export interface MortgageCreationAccessInput {
	isSubscriptionLoading: boolean;
	isMortgageCountLoading: boolean;
	currentMortgageCount: number;
	canCreate: (limitKey: "mortgages_per_property", currentCount: number) => boolean;
}

export interface MortgageCreationAccessResult {
	isGateReady: boolean;
	canCreateMortgage: boolean;
}

export const resolveMortgageCreationAccess = ({
	isSubscriptionLoading,
	isMortgageCountLoading,
	currentMortgageCount,
	canCreate,
}: MortgageCreationAccessInput): MortgageCreationAccessResult => {
	const isGateReady = !isSubscriptionLoading && !isMortgageCountLoading;

	return {
		isGateReady,
		canCreateMortgage:
			isGateReady && canCreate("mortgages_per_property", currentMortgageCount),
	};
};
